export const getDocIcon = (name: string): string => {
  const icons = {
    doc: "fa-file-word-o",
    pdf: "fa-file-pdf-o",
    docx: "fa-file-word-o",
    xls: "fa-file-excel-o",
    xlsx: "fa-file-excel-o",
    ppt: "fa-file-powerpoint-o",
    jpeg: "fa-file-image-o",
    jpg: "fa-file-image-o",
    JPEG: "fa-file-image-o",
    png: "fa-image",
    mp4: "fa-file-video-o",
    mov: "fa-file-video-o",
    avi: "fa-file-video-o",
  };

  const fileNameParts = name.split(".");
  const extension = fileNameParts[fileNameParts.length - 1];

  if (extension in icons) {
    return icons[extension];
  }

  return "fa-file-text-o";
};

export const getDocIconColor = (name: string): string => {
  const icons = {
    doc: "blue",
    pdf: "orange",
    docx: "blue",
    xls: "green",
    xlsx: "green",
    ppt: "red",
    jpeg: "orange",
    jpg: "orange",
    JPEG: "orange",
    png: "orange",
    mp4: "orange",
    mov: "orange",
    avi: "orange",
  };

  const fileNameParts = name.split(".");
  const extension = fileNameParts[fileNameParts.length - 1];

  if (extension in icons) {
    return icons[extension];
  }

  return "indigo";
};

export const getFileSize = (size: number): string => {
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const bytes = size * 1024;

  if (bytes == 0) {
    return "0 B";
  }

  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  return `${Math.round(bytes / Math.pow(1024, i))} ${sizes[i]}`;
};

export const fromFileListToListOfFiles = (fileList: FileList): File[] => {
  const files: File[] = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < fileList.length; i++) {
    files.push(fileList[i]);
  }

  return files;
};
